var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
import { getDisplaysForCampaignSlice } from './slice-components/getDisplaysForCampaign';
import { assignDisplaySlice } from './slice-components/assignDisplay';
import { createCampaignSlice } from './slice-components/create';
import { updateCampaignSlice } from './slice-components/update';
import { getDetailSlice } from './slice-components/getDetail';
import { getAllSlice } from './slice-components/getAll';
import { CAMPAIGN_TYPE, } from './types';
import dayjs from 'dayjs';
export var formikCreateUpdateInitialValue = {
    name: '',
    start_datetime: null,
    end_datetime: null,
    display_duration: 10,
    type: '',
    is_all_day: true,
    window_times: [
        {
            start_window_time: dayjs().startOf('day').format('YYYYMMDDHHmm'),
            end_window_time: dayjs().endOf('day').format('YYYYMMDDHHmm'),
        },
    ],
    campaign_type: CAMPAIGN_TYPE.STANDARD,
};
export var formikFilterInitialValue = {
    name: '',
    route: null,
    sequence: null,
    displayId: null,
    type: '',
    status: 'ACTIVE',
    start: null,
    end: null,
    campaignType: 'ALL',
};
export var formikAssignDialogFilterInitialValue = {
    vehicle_number: '',
    route: '',
    geofence: '',
    vehicle_group: '',
};
export var formikRouteAssignFilterInitialValue = {
    routeNumber: '',
};
export var getAllCampaignsDataResponse = {
    totalPage: 0,
    pageSize: 0,
    pageIdx: 0,
    campaignCount: 0,
    filterCount: 0,
    campaigns: [],
};
export var getDisplaysForCampaignDataRepsonse = {
    displayCount: 0,
    filterCount: 0,
    displays: [],
};
export var initcreateCampaignsResponse = {
    errorCode: '',
    errorMessage: '',
    errorParam: '',
    status: '',
};
var initialState = {
    pending: false,
    getAllCampaignsResponse: {
        errorCode: '',
        data: getAllCampaignsDataResponse,
        errorMessage: '',
        errorParam: '',
        status: '',
    },
    getDisplaysForCampaignResponse: {
        errorCode: '',
        data: getDisplaysForCampaignDataRepsonse,
        errorMessage: '',
        errorParam: '',
        status: '',
    },
    createCampaignsResponse: initcreateCampaignsResponse,
    updateCampaignsResponse: {
        errorCode: '',
        errorMessage: '',
        errorParam: '',
        status: '',
    },
    assignDisplayResponse: {
        errorCode: '',
        errorMessage: '',
        errorParam: '',
        status: '',
    },
    getDetailCampaignResponse: {
        errorCode: '',
        errorMessage: '',
        errorParam: '',
        status: '',
    },
    error: null,
};
var campaignSlice = createSlice({
    name: 'campaign',
    initialState: initialState,
    reducers: __assign(__assign(__assign(__assign(__assign(__assign({}, getAllSlice), createCampaignSlice), getDetailSlice), updateCampaignSlice), getDisplaysForCampaignSlice), assignDisplaySlice),
});
export var getAllCampaignSuccess = (_a = campaignSlice.actions, _a.getAllCampaignSuccess), getAllCampaignFailed = _a.getAllCampaignFailed, createCampaignSuccess = _a.createCampaignSuccess, createCampaignFailed = _a.createCampaignFailed, getDetailCampaignSuccess = _a.getDetailCampaignSuccess, getDetailCampaignFailed = _a.getDetailCampaignFailed, updateCampaignSuccess = _a.updateCampaignSuccess, updateCampaignFailed = _a.updateCampaignFailed, getDisplaysForCampaignSuccess = _a.getDisplaysForCampaignSuccess, getDisplaysForCampaignFailed = _a.getDisplaysForCampaignFailed, assignDisplaySuccess = _a.assignDisplaySuccess, assignDisplayFailed = _a.assignDisplayFailed;
export default campaignSlice.reducer;
